import { COUPON_STATUS } from "constants/coupon";

export const isFulfilled = (statusItems = []) =>
  !statusItems.some(({ code }) => code === COUPON_STATUS.UNFULFILLED);

export default isFulfilled;
